export const CRA_BAKERY_CLASSIFICATIONS = {
  needs_review: 'Needs review',
  basic_grocery: 'Basic grocery',
  six_serving: 'Six-serving baked good',
  whole_cake: 'Whole or custom cake',
  taxable: 'Taxable item'
};

const servingValue = (value) => {
  const number = Number(value);
  return Number.isInteger(number) && number > 0 ? number : 1;
};

export const getCraBakeryBasketStatus = (selectedItems, offerings) => {
  const selected = Object.entries(selectedItems || {})
    .map(([id, item]) => ({
      offering: offerings.find((entry) => entry.id === id),
      quantity: Number(item?.quantity) || 0
    }))
    .filter(({ offering, quantity }) => offering && quantity > 0);

  const sixServingItems = selected.filter(
    ({ offering }) => offering.cra_bakery_tax_classification === 'six_serving'
  );
  const qualifyingServings = sixServingItems.reduce(
    (total, { offering, quantity }) => (
      total + quantity * servingValue(offering.cra_servings_per_unit)
    ),
    0
  );

  let checkoutIssue = '';

  for (const { offering } of selected) {
    const classification = offering.cra_bakery_tax_classification || 'needs_review';

    if (classification === 'needs_review') {
      checkoutIssue = `${offering.title} needs seller tax review before online checkout.`;
      break;
    }

    if (
      classification === 'six_serving'
      && offering.cra_qualifying_packaging !== true
    ) {
      checkoutIssue = `${offering.title} needs its packaging classification reviewed before online checkout.`;
      break;
    }

    if (
      classification === 'whole_cake'
      && offering.cra_cake_individually_qualifies !== true
    ) {
      checkoutIssue = `${offering.title} needs individual cake eligibility review before online checkout.`;
      break;
    }
  }

  return {
    hasSixServingItems: sixServingItems.length > 0,
    qualifyingServings,
    minimumMet: sixServingItems.length === 0 || qualifyingServings >= 6,
    checkoutIssue
  };
};
